/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { csoCustomerOrder } from '@/api/ajax';
export default [
  // TODO: 缺少项目搜索
  {
    id: 'projectId',
    key: 'projectId',
    tip: '项目名称',
    label: '项目名称',
    required: false,
    slot: 'ajaxSelect',
    ajax: csoCustomerOrder.listAllProjectForSelect,
    prop: {
      label: 'projectName',
      code: 'project_id'
    },
    ajaxQuery: 'projectName',
    // TODO: 需求是要支持多选，接口暂时不支持
    // multiple:true,
    width: 'auto'
  },
  {
    id: 'taskDt',
    key: 'taskDt',
    slot: 'date',
    width: 180,
    tip: '任务月度',
    label: '任务月度'
  },
  {
    id: 'fullName',
    key: 'fullName',
    width: 180,
    tip: '项目参与人',
    label: '项目参与人',
    slot: 'input'
  },
  {
    id: 'phone',
    key: 'phone',
    width: 180,
    tip: '手机号',
    label: '手机号',
    slot: 'input'
  }
];
